module.exports = __webpack_public_path__ + "artbox-logo-horiz-small@3x.779c0425.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/artbox-logo-horiz-small@3x.png
 ** module id = 208
 ** module chunks = 0
 **/